// extracted by mini-css-extract-plugin
export var container = "_di-1";
export var cornerButtonContainer = "_di-6";
export var disabled = "_di-2";
export var dragActive = "_di-3";
export var fileContainer = "_di-5";
export var hiddenInput = "_di-4";
export var widthContainer = "_di-0";